<!-- Overlay -->
<div class="fixed inset-0 
            bg-black/50 dark:bg-black/70 
            backdrop-blur-sm
            flex items-center justify-center z-[80]">

    <!-- Contenedor -->
    <div
        class="relative w-full flex flex-col p-4 max-h-[100dvh] min-h-0"
        [ngClass]="modalSizes[size]"
    >

        <!-- Modal -->
        <div class="bg-[var(--color-surface)] 
                    border border-[var(--color-border)] 
                    rounded-xl shadow-xl 
                    flex flex-col min-h-0 max-h-full">

        <!-- Header -->
        <div class="flex items-center justify-between 
                    border-b border-[var(--color-border)] 
                    px-4 py-3">

            <h3 class="text-base font-semibold text-[var(--color-heading)]">
            {{ title }}
            </h3>

            <button 
            type="button" 
            class="w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer
                    text-[var(--color-body)]
                    hover:bg-[var(--color-surface-muted)] 
                    hover:text-[var(--color-heading)]"
            (click)="close()"
            >
            <fa-icon [icon]="closeIcon" />
            </button>
        </div>

        <!-- Body -->
        <div class="flex-1 min-h-0 overflow-y-auto p-4">
            <ng-container #content></ng-container>
        </div>

        @if (showActions) {
            <div class="flex justify-end gap-2 
                        px-4 py-3 
                        border-t border-[var(--color-border)]">

            <!-- Cancel -->
            <button 
                (click)="close()" 
                class="px-4 py-2 rounded-lg text-sm
                        border border-[var(--color-border)]
                        text-[var(--color-body)]
                        hover:bg-[var(--color-surface-muted)]">
                Cancelar
            </button>

            <!-- Confirm -->
            <button 
                (click)="confirm?.()" 
                class="px-4 py-2 rounded-lg text-sm
                        bg-[var(--color-primary)] 
                        text-white
                        hover:bg-[var(--color-primary-hover)]
                        focus:ring-2 focus:ring-[var(--color-primary-active)]/20">
                Confirmar
            </button>

            </div>
        }

        </div>
    </div>
</div>